import Vue from "vue";

import currencyService from "../../../_common/services/currency.service";

Vue.filter("spsCurrency", formatSweepstakesCurrency);

function formatSweepstakesCurrency(sourceAmount) {
    const currency = store.get('currency') || store.get('hall/currency');
    const placeCurrencyAtLeft = !!store.get('sweepstakesBalance');
    let maximumFractionDigits = 2;
    let locale = Vue.state.lang.currentLocale;
    if (currency === 'KES') {
        maximumFractionDigits = 0;
        locale = 'ru-RU';
    }

    return currencyService.format(sourceAmount, currency, maximumFractionDigits, placeCurrencyAtLeft, locale);
}


// WEBPACK FOOTER //
// ./skins/xkiosk/filters/currency.filter.js